import type { ExtendedRouteObject } from '#/routes/types';
import loader, { id, type LoaderData, type Params } from './loader';

export default {
  id,
  path: '/underskriftsrum',
  loader,
  lazy: {
    Component: async () => (await import('./index')).default,
  },
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
